import styled, { css } from "styled-components";
import tw from "twin.macro";

import { CollapseExpandSingleIcon } from "../Icons";
import { InputMode, InputSize } from "../Input/types";
import { Trigger } from "../Trigger";

export const StyledSelectTrigger = styled(Trigger)<{
  $size?: InputSize;
  $invalid?: boolean;
  $mode?: InputMode;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px 0 8px;
  width: 300px;
  transition: border-color 0.3s ease;
  background-color: transparent;
  border: none;

  ${({ $mode }) =>
    $mode === "outlined" &&
    css`
      border: 1px solid var(--color-theme-500);
      background-color: var(--input-background-color);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 50%;
      cursor: default;
    `}

  ${({ $invalid, disabled, $mode }) =>
    !$invalid &&
    !disabled &&
    $mode === "outlined" &&
    css`
      &:hover,
      &:focus {
        border-color: var(--color-primary-700);
      }
    `}

  ${({ $invalid, $mode }) =>
    $invalid &&
    $mode === "outlined" &&
    css`
      ${tw`tw-border-alert`}

      &:hover {
        ${tw`tw-border-alert`}
      }
    `}

  ${({ $size }) =>
    $size === "small" &&
    css`
      height: 24px;
      border-radius: var(--ac-br-6);
    `}

  ${({ $size }) =>
    $size === "regular" &&
    css`
      height: 32px;
      border-radius: var(--ac-br-8);
    `}

    ${({ $size }) =>
    $size === "big" &&
    css`
      height: 40px;
      border-radius: var(--ac-br-8);
    `};

  ${({ $size }) =>
    $size === "biggest" &&
    css`
      height: 48px;
      border-radius: var(--ac-br-8);
    `};
`;

StyledSelectTrigger.displayName = "StyledSelectTrigger";

export const StyledCaretIcon = styled(CollapseExpandSingleIcon)<{
  $open: boolean;
}>`
  margin-left: 8px;
  flex-shrink: 0;
  transition: transform 200ms ease;

  ${({ $open }) =>
    !$open &&
    css`
      transform: rotate(180deg);
    `}
`;

StyledCaretIcon.displayName = "StyledCaretIcon";
